/**
 * Clock of the view read's time budget. Reads take only what a frame can spare; specs pin this
 * clock so a loaded host does not cut their context, while motion keeps the real clock.
 */
export const viewReadClock = { now: (): number => performance.now() };
